<template>
  <section class="contact-section py-5">
    <div class="container">
      <h2 class="mb-4 text-uppercase fw-bold text-center text-primary">
        <i class="fa fa-phone text-primary"></i> {{ $t("contact.title") }}
      </h2>
      <p class="text-center">{{ $t("contact.description") }}</p>

      <div class="row g-4">
        <!-- Informații de contact -->
        <div class="col-md-5">
          <div class="contact-info p-4 shadow rounded-3 bg-white">
            <h4 class="fw-bold text-primary mb-3">
              <i class="fa fa-info-circle me-2"></i>{{ $t("contact.company") }}
            </h4>
            <ul class="list-unstyled">
              <li class="mb-2"><i class="fa fa-map-marker me-2"></i> <strong>{{ $t("contact.address") }}:</strong> Strada Republicii nr. 2, Turnu Măgurele, România</li>
                <li class="mb-2"><i class="fa fa-map-marker me-2"></i> <strong>{{ $t("contact.address2") }}:</strong> Sos. Portului nr. 2A, Turnu Măgurele, România</li>
              <li class="mb-2"><i class="fa fa-mobile me-2"></i> <strong>{{ $t("contact.mobile") }}:</strong> <a href="tel:+40766638391">+40 766 638 391</a></li>
              <li class="mb-2"><i class="fa fa-envelope me-2"></i> <strong>{{ $t("contact.email") }}:</strong> <a href="mailto:eurobac2005@gmail.com">eurobac2005@gmail.com</a></li>
            </ul>

            <h5 class="fw-bold text-primary mt-4"><i class="fa fa-building me-2"></i>{{ $t("contact.company") }}</h5>
            <ul class="list-unstyled">
              <li class="mb-2"><i class="fa fa-file me-2"></i> <strong>{{ $t("contact.regCom") }}:</strong> J34/390/2005</li>
              <li class="mb-2"><i class="fa fa-id-card me-2"></i> <strong>{{ $t("contact.cif") }}:</strong> RO17670528</li>
            </ul>

            <h5 class="fw-bold text-primary mt-4"><i class="fa fa-university me-2"></i>{{ $t("contact.bank") }}</h5>
            <ul class="list-unstyled">
              <li class="mb-2"><i class="fa fa-university me-2"></i> Banca Transilvania</li>
              <li class="mb-2"><i class="fa fa-credit-card me-2"></i> RO46BTRLRONCRT0307224601(RON)</li>
              <li class="mb-2"><i class="fa fa-credit-card me-2"></i> RO93BTRLEURCRT0307224601(EUR)</li>
            <li class="mb-2"><i class="fa fa-university me-2"></i> Trezoreria Turnu Magurele</li>
       
              <li class="mb-2"><i class="fa fa-credit-card me-2"></i> RO23TREZ6075069XXX002122</li>     </ul>
            <h5 class="fw-bold text-primary mt-4"><i class="fa fa-map me-2"></i>{{ $t("contact.gps") }}</h5>
            <p class="mb-3"><i class="fa fa-map me-2"></i> 43.713146, 24.888663</p>

            <!-- Hartă Google Maps -->
            <iframe 
              class="w-100 rounded shadow-sm"
              height="250"
              loading="lazy"
              allowfullscreen
              referrerpolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d240.59462134529764!2d24.888684949839373!3d43.71311361193208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40ac6ab24e3e541b%3A0x1b06ed666a51f72e!2sTurnu%20M%C4%83gurele!5e0!3m2!1sen!2sro!4v1741049693401!5m2!1sen!2sro">
            </iframe>
          </div>
        </div>

        <!-- Formular de contact -->
        <div class="col-md-7">
          <div class="contact-form p-4 shadow rounded-3 bg-white">
            <h4 class="fw-bold text-primary mb-3"><i class="fa fa-envelope me-2"></i>{{ $t("contact.formTitle") }}</h4>
            <form @submit.prevent="sendMessage">
              <div class="mb-3">
                <label class="form-label">{{ $t("contact.name") }}</label>
                <input type="text" class="form-control" v-model="formData.name" required />
              </div>
              <div class="mb-3">
                <label class="form-label">{{ $t("contact.email") }}</label>
                <input type="email" class="form-control" v-model="formData.email" required />
              </div>
              <div class="mb-3">
                <label class="form-label">{{ $t("contact.message") }}</label>
                <textarea class="form-control" rows="4" v-model="formData.message" required></textarea>
              </div>
              <button type="submit" class="btn btn-primary w-100">
                <i class="fa fa-paper-plane me-2"></i>{{ $t("contact.button") }}
              </button>
              <p v-if="successMessage" class="text-success mt-2">{{ successMessage }}</p>
              <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.contact-section {
  background: #f8f9fa;
  padding: 50px 0;
}

.contact-info, .contact-form {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.contact-info iframe {
  border-radius: 12px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.fa {
  color: #0056b3;
}

@media (max-width: 768px) {
  .contact-info, .contact-form {
    margin-bottom: 20px;
  }
}
</style>


  
<script>
import axios from "axios";

export default {
  name: "ContactPage",
  data() {
    return {
      formData: {
        name: "",
        email: "",
        message: "",
      },
      successMessage: "",
      errorMessage: "",
    };
  },
  methods: {
    async sendMessage() {
      try {
        const response = await axios.post("https://api.feribot-eurobac.ro/contact", this.formData);
        if (response.status === 200) {
          this.successMessage = this.$t("contact.success");
          this.formData = { name: "", email: "", message: "" }; // Resetează formularul
          this.errorMessage = "";
        }
      } catch (error) {
        this.errorMessage = this.$t("contact.error");
      }
    },
  },
};
</script>
